import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Breadcrumb, BreadcrumbItem } from '../../Generic/Breadcrumb';
import styles from './Breadcrumb-tw-styles';
import SEOBreadcrumb from '../SEO/SEOBreadcrumb';
import getPageHierarchy from '../../../utils/url-manager/urlHierarchyHelper';
import i18nMessages from '../../../constants/messages/pt-BR';

const PageBreadcrumb = props => {
  const { currentUrl, locale, pageType } = props;
  let revisedCurrentUrl = currentUrl;
  if (currentUrl.indexOf('#') > -1) {
    revisedCurrentUrl = currentUrl.substring(0, currentUrl.indexOf('#'));
  }
  const pageData = getPageHierarchy(revisedCurrentUrl, locale, pageType);
  const breadCrumbData = [];
  pageData.forEach((page, index) => {
    const showItemClass =
      pageData.length - 1 === index || pageData.length - 2 === index
        ? i18nMessages.block
        : i18nMessages.hiddenmdinlineblock;
    const lastItemClass =
      pageData.length - 1 === index ? i18nMessages.fontbold : '';
    const breadcrumbItemStyle = classNames(
      styles.breadcrumb_li.list_li,
      showItemClass,
      lastItemClass
    );

    breadCrumbData.push(
      <BreadcrumbItem
        className={classNames(breadcrumbItemStyle)}
        linkClassName={classNames(styles.breadcrumb_li.list_link)}
        component="li"
        to={page.path}
        labelText={page.breadCrumbTitle}
        separator="/"
        active={pageData.length === index + 1}
        key={index}
        keyIndex={index}
      />
    );
  });
  return (
    <div className={styles.breadcrumbMainDiv}>
      <Breadcrumb className={classNames(styles.breadcrumb_li.list_item)}>
        {breadCrumbData}
      </Breadcrumb>
      <SEOBreadcrumb locale={locale} data={breadCrumbData} />
    </div>
  );
};

PageBreadcrumb.propTypes = {
  locale: PropTypes.string.isRequired,
  currentUrl: PropTypes.string.isRequired,
  pageType: PropTypes.string,
};
// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const PageBreadcrumb = ({prop = val, pageType = null }) =>
// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const Breadcrumb = ({prop = val, component = 'ul' }) =>

export default PageBreadcrumb;
